import { generateUrl } from "@services/generateUrl/generateUrl";
import BasicHttpResponseI from "../interfaces/basic-http-respons";
import BasicProfileI, {
    ActivationEmailI,
    BasicInformation,
    BasicInformationM,
    VerificationCodeI,
} from "../interfaces/basic-profileI";
import PractitionerProfileI, { IPractitionerProfile, PractitionerProfileOriginl } from "../interfaces/practitioner-profileI";
import SignUpDataI from "../interfaces/singup-dataI";
import UserRolesI from "../interfaces/user-rolesI";
import axiosApiInstance from "./custom-axios-instance";
import axios from "axios";
import { codeApp } from "@interfaces/organizationI";
import drProxPractitionerApiInstance from "./clients/drproxpractitioner";
import signupServiceApiInstance from "./clients/signup.old";

/**
 * Check if email is already registered or not
 * @param email to validate
 * @returns {BasicHttpResponseI} if user exists or not
 */
export function verifyUserByEmail(email: string): Promise<BasicHttpResponseI> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/signup/user/validate/exists/${window.btoa(email)}`
        )
        .then((response) => {
            const data: BasicHttpResponseI = {
                code: response.data.code,
                message: response.data.message,
                response: response.data.response,
            };
            return data;
        });
}

export function signUpProfessional(credentials: SignUpDataI, appOrigin: codeApp): Promise<BasicProfileI> {
    return axiosApiInstance
        .post(
            `${generateUrl()}/signup/person/practitioner/?appOrigin=${appOrigin}`,
            credentials
        )
        .then((response) => {
            const profile = response.data as unknown;
            return profile as BasicProfileI;
        });
}
export function signUpProfessionalKC(credentials: SignUpDataI, appOrigin: codeApp, token:string, recaptchaToken?: string): Promise<BasicProfileI> {
    return axios
        .post(
            `${generateUrl()}/signup/person/practitioner/?appOrigin=${appOrigin}`,
            credentials,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    ...(recaptchaToken ? { 'X-Recaptcha-Token': recaptchaToken } : {}),
                },
            }
        )
        .then((response) => {
            const profile = response.data as unknown;
            return profile as BasicProfileI;
        });
}
export function signUpProfessionalM(credentials: SignUpDataI, appOrigin: codeApp): Promise<BasicProfileI> {
    return axiosApiInstance
        .post(
            `${generateUrl()}/signup/person/practitioner/?appOrigin=${appOrigin}`,
            credentials
        )
        .then((response) => {
            const profile = response.data as unknown;
            return profile as BasicProfileI;
        });
}
export function signUpProfessionalKCM(credentials: SignUpDataI, appOrigin: codeApp, token:string): Promise<BasicProfileI> {
    return axios
        .post(
            `${generateUrl()}/signup/person/practitioner/?appOrigin=${appOrigin}`,
            credentials,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        .then((response) => {
            const profile = response.data as unknown;
            return profile as BasicProfileI;
        });
}

export function getVerificationCode(
    personId: number
) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/signup/verification/code/${personId}`
        )
        .then((response) => {
            const profile = response.data as unknown;
            return profile as {
                id: number;
                personId: number;
                isActive: boolean;
                codeStatusId: number;
                value: string;
                systemCreatedAt: string;
                systemUpdatedAt: string;
            };
        });
}
/**
 * Reads basic user profiles
 * @param email encrypted in base 64
 * @returns BasicProfileI object promise
 */
export function getRegistrationByEmail(email: string): Promise<BasicProfileI> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/signup/person/email/${email}`
        )
        .then((response) => {
            const profile = response.data as unknown;
            return profile as BasicProfileI;
        });
}
/**
 * Reads basic user profiles
 * @param email encrypted in base 64
 * @returns BasicProfileI object promise
 */
export function getRegistrationByEmailKC(email: string, token:string): Promise<BasicProfileI> {
    return axios
        .get(
            `${generateUrl()}/signup/person/email/${email}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        .then((response) => {
            const profile = response.data as unknown;
            return profile as BasicProfileI;
        });
}

/**
 * Reads basic user profiles
 * @param username encrypted in base 64
 * @returns BasicProfileI object promise
 */
export function getBasicInformationUser(
    usernameEncode: string
): Promise<BasicInformation> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/signup/person/username/${usernameEncode}`
        )
        .then((response) => {
            const profile = response.data as unknown;
            return profile as BasicInformation;
        });
}
export async function getBasicInformationUserMongo(usernameEncode: string) 
{
    const endpoint = `/person/username/mongo/${usernameEncode}`;
    const data = await signupServiceApiInstance.get<BasicInformationM>(endpoint);
    return data.data;
}

export function getBasicInformationByEmail(
    emailEncode: string
): Promise<BasicInformation> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/signup/person/email/${emailEncode}`
        )
        .then((response) => {
            const profile = response.data as unknown;
            return profile as BasicInformation;
        });
}
/**
 * Asks for a new verification code for the user
 * @param personId
 * @returns the VerificationCodeI object {personId, verificationCode}
 */
export function renewVerificationCode(
    personId: number
): Promise<VerificationCodeI> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/signup/verification/code/${personId}`
        )
        .then((response) => {
            const profile = response.data as unknown;
            return profile as VerificationCodeI;
        });
}
export function renewVerificationCodeKC(
    personId: number,
    token: string
): Promise<VerificationCodeI> {
    return axios
        .get(
            `${generateUrl()}/signup/verification/code/${personId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        .then((response) => {
            const profile = response.data as unknown;
            return profile as VerificationCodeI;
        });
}

export function sendVerificationEmail(
    data: ActivationEmailI
): Promise<unknown> {
    return axiosApiInstance.post(
        `${generateUrl()}/notification/account/email/activate`,
        data
    );
}
export function sendVerificationEmailKC(
    data: ActivationEmailI,
    token:string
): Promise<unknown> {
    return axios.post(
        `${generateUrl()}/notification/account/email/activate`,
        data,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
}

/**
 * @deprecated Use `getPractitionerProfileData` instead.
 */
export function readPractitionerProfile(
    username: string
): Promise<PractitionerProfileI> {

    return axiosApiInstance
        .get(
            `${generateUrl()}/signup/person/practitioner/profile/${username}`
        )
        .then((response) => {
            const practitionerProfile = response.data as unknown;
            return practitionerProfile as PractitionerProfileI;
        });
}

/**
 * @deprecated
 */
export function readPractitionerProfileOriginal(
    username: string
){
    return axiosApiInstance
        .get(
            `${generateUrl()}/signup/person/practitioner/profile/${username}`
        )
        .then((response) => {
            const practitionerProfile = response.data as unknown;
            return practitionerProfile as PractitionerProfileOriginl;
        });
}


export async function getPractitionerProfileData(username: string): Promise<IPractitionerProfile>
{
    const endpoint = `/api/v1/practitioner/profile/${username}`;
    const response = await drProxPractitionerApiInstance.get<IPractitionerProfile>(endpoint);
    return response.data;
}

/**
 * Read user roles and basic data
 * @param {string} username(username|email) to retrieve roles
 * @returns {Promise<UserRolesI>}
 * @deprecated
 */
export function readUserRoles(username: string): Promise<UserRolesI> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/signup/user/rol/${username}`
        )
        .then((response) => {
            const practitionerProfile = response.data as unknown;
            return practitionerProfile as UserRolesI;
        });
}
/**
 * Send verification data to activate user
 * @param code to verify the user
 * @param username to verify
 * @returns Verification status
 */
export function verifyUser(
    code: string,
    username: string
): Promise<UserRolesI> {
    return axiosApiInstance
        .post(
            `${generateUrl()}/signup/verification/code/by-username/`,
            { username, value: code }
        )
        .then((response) => {
            const practitionerProfile = response.data as unknown;
            return practitionerProfile as UserRolesI;
        });
}
export function verifyUserKC(
    code: string,
    username: string,
    token: string
): Promise<UserRolesI> {
    return axios
        .post(
            `${generateUrl()}/signup/verification/code/by-username/`,
            { username, value: code },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        .then((response) => {
            const practitionerProfile = response.data as unknown;
            return practitionerProfile as UserRolesI;
        });
}
/**
 * Gets if a practitioner is already active or not
 * @param username
 * @return {boolean} Practitioner is active or not
 * @deprecated
 */
export function practitionerIsActive(username: string): Promise<boolean> {
    return axiosApiInstance
        .get(
            `${generateUrl()}/drprox/practitioner/active/${username}`
        )
        .then((data) => {
            const isActive = data.data as unknown;
            return isActive as boolean;
        });
}

/**
 * Gets if a practitioner is already active or not
 * @return {boolean} Practitioner is active or not
 */
export async function getIsPactitionerActive(): Promise<boolean> 
{
    const endpoint = "/api/v1/practitioner/status";
    const data = await drProxPractitionerApiInstance.get<boolean>(endpoint);
    return data.data;
}

export function getPractitionerStatus(username: string) {
    return axiosApiInstance
        .get(
            `${generateUrl()}/signup/person/user/${username}/role/PR`
        )
        .then((data) => {
            const isActive = data.data as unknown;
            return isActive as {
                username: string;
                statusCode: string;
                initialQuiz: boolean;
                isWalkthrough: boolean;
            };
        });
}

export function sendEmailToRecoverPassword(
    data: {
        email: string;
        recoveryUrl: string;
        templateCode: string;
        languageCode: string;
    }
    ) {
    return axiosApiInstance
        .post(
            `${generateUrl()}/notification/fc/recover/password`,
            data
        )
        .then((responce) => {
            const res = responce.data as unknown;
            return res as {code: string, message: string};
        });
}
export function sendEmailToRecoverPasswordKC(
    data: {
        email: string;
        recoveryUrl: string;
        templateCode: string;
        languageCode: string;
        appOrigin: string;
    },
    token:string
    ) {
    return axios
        .post(
            `${generateUrl()}/notification/fc/recover/password`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        .then((responce) => {
            const res = responce.data as unknown;
            return res as {code: string, message: string};
        });
}

export function changePassword(
    data: {
        usernameOrEmail: string;
        password: string;
    }
    ) {
    return axiosApiInstance
        .put(
            `${generateUrl()}/signup/user/change-password`,
            data
        )
        .then((responce) => {
            const res = responce.data as unknown;
            return res as {code: string, message: string};
        });
}
export function changePasswordKC(
    data: {
        usernameOrEmail: string;
        password: string;
    },
    token:string
    ) {
    return axios
        .put(
            `${generateUrl()}/signup/user/change-password`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        .then((responce) => {
            const res = responce.data as unknown;
            return res as {code: string, message: string};
        });
}

export function finishWalktrough(personId: number, value: boolean) {
    return axiosApiInstance
        .post(
            `${generateUrl()}/signup/person/user/${personId}/role/PR/walkthough/${value}`
        )
        .then((data) => {
            const isActive = data.data as unknown;
            return isActive as {
                username: string;
                statusCode: string;
                initialQuiz: boolean;
                isWalkthrough: boolean;
            };
        });
}

export function addNewUserRole(data: {
    roleCode: string,
    username: string
  }){
    return axiosApiInstance
        .put(
            `${generateUrl()}/signup/user/active/new/role`,
            data
        )
        .then((response) => {
            const successMessage = response.data as unknown;
            return successMessage as { code: string; message: string };
        });
}
export function handleRoleStatus(data: {
    active: boolean,
    roleCode: string,
    username: string
  }){
    return axiosApiInstance
        .put(
            `${generateUrl()}/signup/user/active-role`,
            data
        )
        .then((response) => {
            const successMessage = response.data as unknown;
            return successMessage as { code: string; message: string };
        });
}
